import store from '@/store'
import { getData } from '@core/utils/http/general'
import { ref } from '@vue/composition-api'

export const a = () => {
}

export const useBajasCatalogos = () => {
  const bajaOptions = ref([])

  const bajaOptionsPromise = new Promise((resolve, reject) => {
    getData({ action: 1, token: store.state.cuenta.session.token }, 'wsbajas')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          bajaOptions.value = response.data.data
          resolve()
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  return {
    bajaOptionsPromise,
    bajaOptions,

  }
}
